import React, { Component } from "react";
import axios from "axios"; // Add axios import
import ListingPage from "../../2/Controls/ListingPage";
import Input from "../../2/Controls/Input";
import Window from "../../2/Controls/Window";
import ExportButton from "../../2/Controls/ExportButton";
import { exportFile } from "../../../actions/DataExporter";
import ImportLog from "../../ImportLog";
import ImportData from "../../ImportData";
import Button from "../../2/Controls/Button";

class VendorList extends Component {

    constructor(props) {

        super(props);

        this.state = {

            list: [],
            totalCount: 0,
            loading: false,

            page: 1,
            pageSize: 25,

            searchParam: "",
            filter: {

                name: "",
                vendorCode: "",
                phoneNo: "",
                emailId: "",
                city: "",
                state: "",
                postalCode: "",
                country: "",
                status: "active"
            },

            showFilter: false,
            showOption: false,
            showImportLog: false,
            showImport: false,
            showDelete: false,

            selectedRow: null,

            isFilterActive: false,

            listPageSettings: {

                Title: "Vendor",

                Search: {

                    showSearch: true,
                    placeholder: "Search by vendor name, email id, phone no",

                    onSearch: this.onSearch,

                    onRefresh: this.onRefreshClick,

                    onFilterClick: () =>
                        this.setState({ showFilter: true }),

                    isFilterActive: false

                },

                HeaderButtons: [

                    {
                        ButtonType: "Button",
                        Type: "primary",
                        Text: "New",
                        Icon: "add",
                        Action: "new"
                    },

                    {
                        ButtonType: "ImageButton",
                        Type: "option",
                        Text: "Options",
                        Icon: "option",
                        Action: "options"
                    }

                ],

                Columns: [
                    { Name: "Code", Type: "field", Columns: [{ Column: "VendorCode" }] },
                    {
                        Name: "Name",
                        Type: "field",
                        Columns: [{ Column: "VendorFirstName" }],
                    },
                    { Name: "Email ID", Type: "field", Columns: [{ Column: "EmailID" }] },
                    { Name: "Phone No", Type: "field", Columns: [{ Column: "PhoneNo" }] },
                    {
                        Name: "Address",
                        Type: "multiple",
                        Columns: [
                            { Column: "Address1" },
                            { Column: "Address2" },
                            { Column: "City" },
                            { Column: "State" },
                            { Column: "Country" },
                        ],
                    },
                    { Name: "Store", Type: "field", Columns: [] },
                    { Name: "Additional Info", Type: "multiple", Columns: [] },
                    {
                        Name: "Name",
                        Type: "field",
                        ShowInMobile: true,
                        Columns: [
                            { Column: "VendorFirstName" },
                            { Column: "EmailID" },
                            { Column: "PhoneNo" },
                        ],
                    },
                ],

                RowButtons: [

                    {
                        ButtonType: "ImageButton",
                        Type: "edit",
                        Text: "Edit",
                        Icon: "edit"
                    },

                    {
                        ButtonType: "ImageButton",
                        Type: "delete",
                        Text: "Delete",
                        Icon: "delete"
                    }

                ]

            }

        };

    }

    componentDidMount() {

        this.loadData();

    }

    // =====================
    // LOAD DATA
    // =====================

    loadData = async () => {

        this.setState({ loading: true });

        try {

            const { page, pageSize, filter, searchParam } =
                this.state;

            const res =

                await this.props.getVendors(

                    (page - 1) * pageSize,          // from
                    pageSize,                       // size
                    filter.status || "active",      // status
                    searchParam,
                    filter.name,
                    "",
                    filter.phoneNo,
                    filter.emailId,                  // Fixed: changed from emailID to emailId
                    filter.city,
                    filter.state,
                    filter.country,
                    filter.postalCode,
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    filter.vendorCode

                );
            
            let list = [];
            let totalCount = 0;

            if (res && res.searchResult) {
                list = res.searchResult;
                totalCount = res.totalItemsCount;
            }

            this.setState({

                list: list,
                totalCount: totalCount,
                loading: false

            });

        }

        catch (error) {

            console.error(error);

            this.setState({
                loading: false
            });

        }

    };

    // =====================
    // SEARCH
    // =====================

    onSearch = (text) => {

        this.setState({

            searchParam: text,
            page: 1

        },

            this.loadData

        );

    };

    onRefreshClick = () => {

        this.setState({

            filter: {
                name: "",
                vendorCode: "",
                phoneNo: "",
                emailId: "",
                city: "",
                state: "",
                postalCode: "",
                country: "",
                status: "active"
            },

            page: 1,
            searchParam: "",
            isFilterActive: false

        },

            this.loadData

        );

    };

    // =====================
    // PAGINATION
    // =====================

    onNextClick = () => {

        const totalPages = Math.ceil(

            this.state.totalCount /
            this.state.pageSize

        );

        if (this.state.page < totalPages) {

            this.setState({

                page: this.state.page + 1

            },

                this.loadData

            );

        }

    };

    onPreviousClick = () => {

        if (this.state.page > 1) {

            this.setState({

                page: this.state.page - 1

            },

                this.loadData

            );

        }

    };

    onFirstClick = () => {

        this.setState({

            page: 1

        },

            this.loadData

        );

    };

    onLastClick = () => {

        const totalPages = Math.ceil(

            this.state.totalCount /
            this.state.pageSize

        );

        this.setState({

            page: totalPages

        },

            this.loadData

        );

    };

    onRecordsPerPageCountChange = (size) => {

        this.setState({

            pageSize: Number(size),
            page: 1

        },

            this.loadData

        );

    };

    // =====================
    // HEADER BUTTON
    // =====================

    onHeaderButtonClicked = (btn) => {

        if (btn.Action === "new") {

            this.props.history.push(
                "/home/settings/vendors/newvendor"  // Fixed: Changed from product to vendor
            );

        }

        if (btn.Action === "options") {

            this.setState({

                showOption: true

            });

        }

    };

    // =====================
    // FILTER
    // =====================

    onApplyFilter = () => {

        this.setState({

            page: 1,
            showFilter: false,
            isFilterActive: true

        },

            this.loadData

        );

    };

    onClearFilter = () => {

        this.onRefreshClick();

        this.setState({

            showFilter: false

        });

    };

    // =====================
    // DELETE
    // =====================

    onRowButtonClicked = (btn, row) => {

        if (btn.Type === "edit") {

            this.props.history.push(
                "/home/settings/vendors/edit/" + row.key  // Fixed: Changed from product to vendor
            );

        }

        if (btn.Type === "delete") {

            this.setState({

                showDelete: true,
                selectedRow: row

            });

        }

    };

    deleteRecord = async () => {
        this.setState({

            showDelete: false,
            loading:true

        },);

        await this.props.deleteVendor(

            this.state.selectedRow.key

        );

         await new Promise(resolve => setTimeout(resolve, 3000));

        this.setState({
            loading:false,
            showDelete: false,
            selectedRow: null

        },);

        await this.loadData();

    };

    // =====================
    // EXPORT
    // =====================
  
    getExportData = async () => {
        const MAX = 10000;
        const { filter, searchParam } = this.state;

        const res = await this.props.getVendors(  // Fixed: Added const res = 
            0,          // from
            MAX,        // size
            filter.status || "active",      // status
            searchParam,
            filter.name,
            "",
            filter.phoneNo,
            filter.emailId,  // Fixed: Changed from emailID to emailId
            filter.city,
            filter.state,
            filter.country,
            filter.postalCode,
            "",
            "",
            "",
            "",
            "",
            "",
            filter.vendorCode
        );

        return res && res.searchResult ? res.searchResult : [];
    };

    handleExport = async (type) => {
        this.setState({ loading: true });
        try {

            const data = await this.getExportData();

            if (!data || !data.length) {

                alert("No data found");
                this.setState({ loading: false });
                return;

            }

            const exportColumns = [
                { header: "Code", field: "VendorCode" },
                { header: "Name", field: "VendorFirstName" },
                { header: "ContactPersonName", field: "VendorLastName" },
                { header: "EmailID", field: "EmailID" },
                { header: "PhoneNo", field: "PhoneNo" },
                { header: "LineAddress1", field: "Address1" },
                { header: "LineAddress2", field: "Address2" },
                { header: "City", field: "City" },
                { header: "StateCode", field: "StateCode" },
                { header: "State", field: "State" },
                { header: "CustomField1", field: "CustomField1" },
                { header: "CustomField2", field: "CustomField2" },
                { header: "CustomField3", field: "CustomField3" },
                { header: "CustomField4", field: "CustomField4" },
                { header: "CustomField5", field: "CustomField5" },
                { header: "CustomField6", field: "CustomField6" }
            ];

            await exportFile({
                data: data,
                columns: exportColumns,
                fileType: type,
                title: "Vendor",
                landscape: true
            });

        }
        catch (error) {
            console.error(error);
            alert("Export failed");
        }
        finally {
            this.setState({ loading: false });
        }

    };

    onImport = () => {

        this.setState({

            showImport: true,
            showOption: false

        });

    };
    
    onImportLog = () => {

        this.setState({

            showImportLog: true,
            showOption: false

        });

    };

    // =====================
    // RENDER
    // =====================

    onPageChange = (page, pageSize) => {
        console.log("page", page);
        this.setState(
            { page, pageSize },
            () => {
                this.loadData();
            }
        );
    };

    render() {

        return (

            <>

                <ListingPage
                    {...this.props}
                    listPageSettings={{

                        ...this.state.listPageSettings,

                        Search: {

                            ...this.state.listPageSettings.Search,

                            isFilterActive: this.state.isFilterActive

                        }

                    }}

                    list={this.state.list}
                    onPageChange={this.onPageChange}

                    loading={this.state.loading}

                    totalItemsCount={this.state.totalCount}

                    recordFrom={
                        (this.state.page - 1) *
                        this.state.pageSize
                    }

                    itemsCountPerPage={this.state.pageSize}

                    onNextClick={this.onNextClick}

                    onPreviousClick={this.onPreviousClick}

                    onFirstClick={this.onFirstClick}

                    onLastClick={this.onLastClick}

                    onRecordsPerPageCountChange={
                        this.onRecordsPerPageCountChange
                    }

                    onHeaderButtonClicked={
                        this.onHeaderButtonClicked
                    }

                    onRowButtonClicked={
                        this.onRowButtonClicked
                    }

                />

                {this.state.showFilter && (

                    <Window

                        header="Filter"

                        size="small"

                        slide

                        onClose={() =>
                            this.setState({
                                showFilter: false
                            })
                        }

                        onButtonClick={(action) => {

                            if (
                                action.toLowerCase() === "apply"
                            ) {

                                this.onApplyFilter();

                            }

                            else if (
                                action.toLowerCase() === "clear"
                            ) {

                                this.onClearFilter();

                            }

                        }}

                        buttons={[
                            {
                                Type: "secondary",
                                Text: "Clear",
                                Align: "left"
                            },
                            {
                                Type: "primary",
                                Text: "Apply",
                                Align: "right"
                            }

                        ]}
                    >

                        <Input
                            type="text"
                            label="Name"
                            value={this.state.filter.name}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        name: v
                                    }
                                })
                            }
                        />

                        <Input
                            type="text"
                            label="Code"
                            value={this.state.filter.vendorCode}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        vendorCode: v
                                    }
                                })
                            }
                        />
                        
                        <Input
                            type="text"  // Changed from "number" to "text" for phone (handles international formats)
                            label="Phone No"
                            value={this.state.filter.phoneNo}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        phoneNo: v
                                    }
                                })
                            }
                        />
                        
                        <Input
                            type="text"
                            label="Email ID"
                            value={this.state.filter.emailId}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        emailId: v
                                    }
                                })
                            }
                        />
                        
                        <Input
                            type="text"
                            label="City"
                            value={this.state.filter.city}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        city: v
                                    }
                                })
                            }
                        />

                        <Input
                            type="text"
                            label="State"
                            value={this.state.filter.state}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        state: v
                                    }
                                })
                            }
                        />

                        <Input
                            type="text"  // Changed from "number" to "text" for postal code
                            label="Postal Code"
                            value={this.state.filter.postalCode}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        postalCode: v
                                    }
                                })
                            }
                        />

                        <Input
                            type="text"
                            label="Country"
                            value={this.state.filter.country}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        country: v
                                    }
                                })
                            }
                        />

                        <Input
                            type="select"
                            label="Status"
                            value={this.state.filter.status}
                            onChange={(v) =>
                                this.setState({
                                    filter: {
                                        ...this.state.filter,
                                        status: v
                                    }
                                })
                            }
                        >

                            <option value="active">
                                Active
                            </option>

                            <option value="inactive">
                                Inactive
                            </option>

                            <option value="all">
                                All
                            </option>

                        </Input>

                    </Window>

                )}

                {this.state.showOption && (

                    <Window
                        header="Options" choiceList
                        size="small"
                        slide
                        onClose={() =>
                            this.setState({
                                showOption: false
                            })
                        }
                    >

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 10,
                                justifyContent: "center",
                                alignItems: "center",
                                flexWrap: "wrap"
                            }}
                        >

                            <ExportButton
                                onExport={this.handleExport}
                                loading={this.state.loading}
                            />

                            <Button
                                type="secondary"
                                text="Import"
                                onClick={this.onImport}
                            />

                            <Button
                                type="secondary"
                                text="Import Log"
                                onClick={this.onImportLog}
                            />

                        </div>

                    </Window>

                )}

                {this.state.showDelete && (

                    <Window

                        header="Delete"

                        modal

                        onClose={() =>
                            this.setState({
                                showDelete: false
                            })
                        }

                        onButtonClick={(btn) => {

                            if (btn === "Yes")
                                this.deleteRecord();

                            else
                                this.setState({
                                    showDelete: false
                                });

                        }}

                        buttons={[
                            {
                                Type: "secondary",
                                Text: "No",
                                Align: "left"
                            },
                            {
                                Type: "primary",
                                Text: "Yes",
                                Align: "right"
                            }

                        ]}

                    >

                        Are you sure you want to delete?

                    </Window>

                )}

                {this.state.showImport && (

                    <ImportData

                        {...this.props}

                        importType="vendor"
                        slide={true}
                        onClose={() =>
                            this.setState({
                                showImport: false
                            })
                        }

                        onImportCompleted={() =>
                            this.loadData()
                        }

                    />

                )}

                {/* IMPORT LOG */}

                {this.state.showImportLog && (

                    <ImportLog

                        {...this.props}

                        importType="vendor"
                        slide={true}

                        onClose={() =>
                            this.setState({
                                showImportLog: false
                            })
                        }

                    />

                )}

            </>

        );

    }

}

export default VendorList;